import React from 'react';
import ModalDrawer from './ModalDrawer';
import Button, { ButtonSizes, ButtonStyles } from '../Button/Button';
import BetaIcon, { IconColors, IconSizes } from '../Icons/Icon';
import { TRANSLATIONS } from '../../../translations';
const FAIL_ICON = 'warning';

const ModalDrawerExitFlow = ({
  isOpen,
  setIsOpen,
  closeAction,
  isDeviceSmallerThanTablet,
}) => {

  return (
    <ModalDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isDeviceSmallerThanTablet={isDeviceSmallerThanTablet}
      modalCustomWidth={600}
      title={TRANSLATIONS.CONFIRM_CANCELLATION}
      content={
        <div className="pl-m pr-m pt-xl pb-xl w-100%">
          <div className="d-flex flex-column items-center pb-2xs gap-xs">
            <BetaIcon
              name={FAIL_ICON}
              color={IconColors.regular}
              size={IconSizes[32]}
            />
          </div>
          {TRANSLATIONS.DO_YOU_REALLY_WANT_TO_STOP_THE_REQUEST}
        </div>
      }
      footer={
        <div className="d-flex justify-center gap-m pb-m pl-xl pr-xl">
          <Button
            classNames={'pr-m pl-m'}
            size={ButtonSizes.s}
            style={ButtonStyles.empty}
            label={<b>{TRANSLATIONS.NO_CONTINUE}</b>}
            onClick={() => setIsOpen(false)}
          />
          <Button
            classNames={'pr-m pl-m'}
            size={ButtonSizes.s}
            style={ButtonStyles.secondary}
            label={<b>{TRANSLATIONS.YES_CANCEL}</b>}
            onClick={closeAction}
          />
        </div>
      }
    />
  );
};

ModalDrawerExitFlow.propTypes = {};

export { ModalDrawerExitFlow };
